import React from 'react';

import { WarningMessage } from '@eika/attention-message';
import { ButtonWithSpinner } from '@eika/button-with-spinner';
import useViewportSize from '@eika/hooks/src/useViewportSize';
import { IconTypes } from '@eika/icon';

import { useConfig } from '../../../../defaultConfig';
import { useOutboxQuery } from '../../../../fetchHooks/useOutbox';
import useTranslation from '../../../../hooks/useTranslation';
import BulkPaymentLink from './BulkPaymentLink';
import PaymentButtonText from './PaymentButtonText';

import './FormApproveSectionWithOutbox.scss';

type FormApproveSectionProps = {
    paymentOperationPending: boolean;
    isPostingOutboxItem: boolean;
    onAddPaymentToApprovalOutbox(event: React.MouseEvent<HTMLButtonElement>): void;
    isApproveDisabled: boolean;
    requireMultipleApprovers: boolean;
};

const FormApproveSectionWithOutbox: React.FC<FormApproveSectionProps> = ({
    paymentOperationPending,
    onAddPaymentToApprovalOutbox,
    isPostingOutboxItem,
    isApproveDisabled,
    requireMultipleApprovers,
}) => {
    const translated = useTranslation();
    const { featureToggles } = useConfig();
    const { data, isLoading } = useOutboxQuery(featureToggles.enableBulkPayment);
    const { paymentsForApprovalLink } = useConfig();
    const [viewportSize] = useViewportSize();
    const LARGE_HANDSET_START = 568;
    const buttonSize = viewportSize > LARGE_HANDSET_START ? 'standard' : 'small';
    const hasBulkPayments = data && data.length > 0;
    return (
        <div className="form-approve-section__container">
            {requireMultipleApprovers && (
                <WarningMessage
                    className="form-approve-section__multi-approval-warning"
                    icon={IconTypes.UTROPSTEGN_24}
                    text={translated.needsAdditionalApproval}
                />
            )}
            <div className="form-approve-section__buttons">
                <ButtonWithSpinner
                    disabled={isApproveDisabled || isLoading}
                    buttonType="negative"
                    size={buttonSize}
                    onClick={onAddPaymentToApprovalOutbox}
                    showSpinner={isPostingOutboxItem}
                    data-testid="create-outbox-payment-button"
                >
                    <PaymentButtonText isOutbox />
                </ButtonWithSpinner>
                <ButtonWithSpinner
                    disabled={isApproveDisabled || isLoading}
                    className="transaction-form--submit"
                    buttonType="positive"
                    size={buttonSize}
                    type="submit"
                    showSpinner={paymentOperationPending}
                >
                    <PaymentButtonText />
                </ButtonWithSpinner>
            </div>
            {hasBulkPayments && !window.location.href.includes(paymentsForApprovalLink?.url ?? '') && (
                <BulkPaymentLink />
            )}
        </div>
    );
};

export default FormApproveSectionWithOutbox;
